const noop = () => {}

export function getFilename(url) {
  let filename
  try {
    filename = new URL(url, 'https://example.com').pathname.split('/').pop()
  } catch (error) {
    console.error(error)
  }

  if (filename) {
    return filename
  }
}

export const getImageAlt = (
  { url, alt } = {},
  i18n = { __: noop, sprintf: noop }
) => {
  const filename = getFilename(url)
  let defaultedAlt

  if (alt) {
    defaultedAlt = alt
  } else if (filename) {
    defaultedAlt = i18n.sprintf(
      /* translators: %s: file name */
      i18n.__(
        'This image has an empty alt attribute; its file name is %s',
        'jgu-base'
      ),
      filename
    )
  } else {
    defaultedAlt = i18n.__('This image has an empty alt attribute', 'jgu-base')
  }

  return defaultedAlt
}

export const sanitizeString = str => {
  str = str.replace(/([^a-z0-9áéíóúñü_-\s,]|[\t\n\f\r\v\0])/gim, '') //eslint-disable-line
  return str.trim().toLowerCase().split(' ').join('-')
}

// Scroll to section
export const scrollIntoViewWithOffset = (el, offset = 0) =>
  window.scrollTo({
    top: el.getBoundingClientRect().top + window.scrollY - offset,
    behavior: 'smooth',
  })

export const isElementInViewport = el => {
  let rect = el.getBoundingClientRect()

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight + 1 ||
        document.documentElement.clientHeight) /* or $(window).height() */ &&
    rect.right <=
      (window.innerWidth ||
        document.documentElement.clientWidth) /* or $(window).width() */
  )
}

export const getThumbnailUrl = imgObj => {
  if (imgObj) {
    if (imgObj.media_details && imgObj.media_details.sizes.medium_large) {
      return imgObj.media_details.sizes.medium_large.source_url
    } else {
      return imgObj.source_url
    }
  }
  return ''
}
